module.exports=function(o){return"object"==typeof o?null!==o:"function"==typeof o};